import * as React from "react"

import { Flex, Box, Link, LinkProps } from "@chakra-ui/react"
import { RiMapPin2Line } from "react-icons/ri"
import { useReverseGeocode } from "../lib/hooks/useReverseGeocode"

interface Props extends LinkProps {
  obj: {
    latitude: number
    longitude: number
  }
}

export const LocationLink = (props: Props) => {
  const address = useReverseGeocode([props.obj.longitude, props.obj.latitude])
  return (
    <Flex align="center">
      <Box as={RiMapPin2Line} boxSize="16px" color="gray.700" mr={1} />
      <Link
        target="_blank"
        rel="noopener nofollower"
        href={`//maps.google.com/?q=${props.obj.latitude},${props.obj.longitude}`}
        color="gray.700"
        fontSize="0.8rem"
        minH="1.2rem"
        whiteSpace="nowrap"
        isTruncated
        {...props}
      >
        {address}
      </Link>
    </Flex>
  )
}
